import { combineReducers } from "redux";

import sidebar from "./sidebarReducers";
import layout from "./layoutReducer";
import theme from "./themeReducer";
import user from './authReducer'
import mfa from './mfaReducer'

import { reducer as toastr } from "react-redux-toastr";

export default combineReducers({
  user,
  mfa,
  sidebar,
  layout,
  theme,
  toastr,
})
